import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'


import { lP, oP, sT } from '../../main.js'

import '../../main.css'
import './Impressum.css'
import './MImpressum.css'


export default function Impressum() {

    return (
        <div className='mainCon' id='mainCon'>
            <MainHeader selectedsite={"impressum"} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Impressum</title>
                <meta property="og:title" content="Impressum" />
                <meta property="og:description" content="Hier finden Sie unser Impressum" />
            </Helmet>
            <section className='sec_next' id='sec_next--impressum'>
                <div className='sec_next_cont' id="sec_next--impressum--cont">
                    {/* <a className="pagebackbtn" href="/">◀️ Zurück zur Startseite</a> */}
                    <h2>Impressum</h2>
                    <p>
                        <b>Angaben gemäß § 5 TMG:</b><br />
                        <br />
                        it.liepert.gmbh<br />
                        Zeissweg 4<br />
                        87700 Memmingen<br />
                        <br />
                        fon 08331.9670.0<br />
                        fax 08331.9670.40<br />
                        eMail info@liepert.de<br />
                        web www.liepert.de<br />
                        <br />
                        Vertretungsberechtigte Geschäftsführer:<br />
                        Klaus Liepert, Ralf Konefal<br />
                        <br />
                        Registergericht: Amtsgericht Memmingen<br />
                        Registernummer: HRB 11090<br />
                        <br />
                        <b><br />
                            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</b><br />
                        <br />
                        DE 212837571<br />
                        <br />
                        <br />
                        <b>Verantwortlich für den Inhalt nach § 55 Abs 2 RStV:</b><br />
                        <br />
                        Klaus Liepert<br />
                        <br />
                        <br />
                        <b>Haftung für Inhalte</b><br />
                        <br />
                        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br />
                        <br />
                        <br />
                        <b>Haftung für Links</b><br />
                        <br />
                        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br />
                        <br />
                        <br />
                        <b>Urheberrecht</b><br />
                        <br />
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.<br />
                        <br />
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.<br />
                        <br />
                        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.<br />
                        <br />
                        <br />

                        <b>Verwendete Icons und Bilder</b><br /><br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/sprechen" title="sprechen Icons">Sprechen Icons erstellt von Freepik - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/lokales-netzwerk" title="lokales netzwerk Icons">Lokales netzwerk Icons erstellt von kerismaker - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/unterstutzung" title="unterstützung Icons">Unterstützung Icons erstellt von netscript - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/datenschutz-bestimmungen" title="datenschutz-bestimmungen Icons">Datenschutz-bestimmungen Icons erstellt von Muhammad_Usman - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/server" title="server Icons">Server Icons erstellt von juicy_fish - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/hardware" title="hardware- Icons">Hardware- Icons erstellt von Triangle Squad - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/phon" title="phon Icons">Phon Icons erstellt von hari-sabana - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/chat-box" title="chat box Icons">Chat box Icons erstellt von Freepik - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/gruppe" title="gruppe Icons">Gruppe Icons erstellt von Prosymbols - Flaticon</a>
                        <br />
                        <a href="https://www.flaticon.com/de/kostenlose-icons/tor" title="tor Icons">Tor Icons erstellt von Freepik - Flaticon</a>
                        <br />
                        Foto von Marten Bjork auf <a href="https://unsplash.com/de/fotos/person-die-mit-brauner-ledertasche-spazieren-geht-6dW3xyQvcYE?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash">Unsplash</a>
                        <br />
                        Foto von Julian Hochgesang auf <a href="https://unsplash.com/de/fotos/schwarzes-ip-tischtelefon-auf-schwarzem-holztisch-Dkn8-zPIbwo?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash">Unsplash</a>
                        <br />
                        Foto von Alexandre Debiève auf <a href="https://unsplash.com/de/fotos/makrofotografie-einer-schwarzen-leiterplatte-FO7JIlwjOtU?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash">Unsplash</a>
                        <br />
                        Foto von Gabrielle Henderson auf <a href="https://unsplash.com/de/fotos/frau-unterschreibt-auf-weissem-druckerpapier-neben-frau-die-die-dokumente-beruhren-will-HJckKnwCXxQ?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash">Unsplash</a>
                        <br />
                        Foto von Thought Catalog auf <a href="https://unsplash.com/de/fotos/person-die-das-telefon-benutzt-YSZS_nDU8js?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash">Unsplash</a>

                        <br />
                        <br />
                        <br />
                        <b>Entwickler der Webseite</b><br /><br />
                        ToNetwork UG (haftungsbeschränkt)<br />
                        <a href="https://tonetwork.de">tonetwork.de</a><br />
                        Im Moos 5<br />
                        87749 Hawangen<br />
                        <br />
                        fon 08332.490.8872<br />
                        eMail info@tonetwork.de<br />
                    </p>
                </div>
            </section>

            <MainFooter />
        </div>
    )
}